"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coreOrganizationsAllUpdateSyncSlice = void 0;
const get_1 = require("./get.js");
const name_1 = require("./name.js");
const xuder_1 = require("@sonar-software/xuder");
exports.coreOrganizationsAllUpdateSyncSlice = (0, xuder_1.createUpdateCollectionSyncSlice)({
    hasRequest: true,
    name: name_1.CoreOrganizationsAllName,
    state: get_1.coreOrganizationsAllGetAsyncSlice.asyncState,
    target: (request) => (organization) => organization.id === request.organizationId,
    update: (request) => (organization) => {
        const organizationAddition = {};
        if (request) {
            const { dailySyncEnabled, name: requestName, packageTagEnabled } = request;
            if (typeof dailySyncEnabled === 'boolean') {
                organizationAddition.dailySyncEnabled = dailySyncEnabled;
            }
            if (requestName) {
                organizationAddition.name = requestName;
            }
            if (typeof packageTagEnabled === 'boolean') {
                organizationAddition.packageTagEnabled = packageTagEnabled;
            }
        }
        return Object.assign(Object.assign({}, organization), organizationAddition);
    }
});
//# sourceMappingURL=update.js.map